const SLIDE_ANIMATIONS = {
    SCROLL: 'SCROLL',
    FADE: 'FADE',
    DECK: 'DECK',
};
export default SLIDE_ANIMATIONS;
//# sourceMappingURL=behaviourParams_gallery_horizontal_slideAnimation.js.map